export default {"src":"/_next/static/media/icon_right_arrow.677b53d1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};